export default class OthController {
  constructor(ContentService, $uibModal, moment, isMobile, ProfilePermissionsService, $state, $translate) {
    this.service = ContentService;
    this.modal = $uibModal;
    this.moment = moment;
    this.isMobile = isMobile;
    this.permissionsService = ProfilePermissionsService;
    this.state = $state;
    this.trans = $translate.instant;
  }

  $onInit(){
    this.subscriptions = [];
    
    this.inMobileView = this.isMobile.phone;
    this.dateFrom = undefined;
    this.dateTo = undefined;
    this.groupBy = '0';
    this.rows = [];
    this.csvHeaderOrder = [];
    this.csvHeaders = [];
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  findOth(groupBy=undefined, cashierId=undefined, posId=undefined, famId=undefined, tableId=undefined){
    this.subscriptions.push(
      this.service.findOth({
        date_from: this.dateFrom.format(),
        date_to: this.dateTo.format(),
        group_by: groupBy || this.groupBy,
        cashier_id: cashierId,
        pos_id: posId,
        fam_id: famId,
        table_id: tableId
      }).subscribe(
        (othList) => {
          this.rows = othList;
          this.reorderCsv();
        },
        (err) => {
          console.log(err);
        }
      )
    );
  }

  getExportRows() {
    return this.rows.map(row => {
      var newRow = angular.copy(row, {});
      if (newRow.date) {
        newRow.date = this.moment(newRow.date).format('DD/MM/YYYY');
      }
      return newRow;
    });
  }

  openBillDetails(invoiceId) {
    var that = this;
    if (this.permissionsService.hasPermission('account-bills') || this.permissionsService.hasPermission('invoice-orders')){
      this.modal.open({
        animation: true,
        size: 'lg',
        templateUrl: 'invoice-details-template.html',
        appendClassName: 'ngdialog-theme-plain',
        controller: ($scope, $uibModalInstance, AccountInformationService) => {
          "ngInject";

          $scope.invoice = {};
          $scope.orders = [];
          $scope.logoUrl = that.service.host + '/api/accounts/logo/' + that.permissionsService.getProfile().account_id + '?t=' + new Date().getTime();
          that.subscriptions.push(
            that.service.getInvoice(invoiceId).subscribe(
              (invoice) => $scope.invoice = invoice,
              (error) => console.log("Error while getting the invoice")
            )
          );

          that.subscriptions.push(
            AccountInformationService.getAccountInfo().subscribe(
              (resp) => {
                $scope.account = resp
              }
            )
          );

          $scope.getOrders = () => {
            if ($scope.orders.length <= 0) {
              that.subscriptions.push(
                that.service.getOrders(invoiceId).subscribe(
                  (orders) => $scope.orders = orders,
                  (error) => console.log("Error while getting the orders")
                )
              );
            };
          };
          $scope.fetchDetails = (order) => {
            if (!order.details || order.details.length <= 0) {
              that.subscriptions.push(
                that.service.getOrderDetails(invoiceId, order.id).subscribe(
                  (details) => {
                    order.details = details;
                    $scope.displayingOrder = order;
                  },
                  (error) => console.log("Error while getting the details for this order")
                )
              );
            };
          };

          $scope.printToCart = (printSectionId) => {
            var innerContents = document.getElementById(printSectionId).innerHTML;
            var popupWinindow = window.open('', '_blank', 'width=1024,height=768,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWinindow.document.open();
            const styleprint = document.evaluate("//head/style[contains(.,'Section_Print')]", document, null, XPathResult.ANY_TYPE).iterateNext();            
            const styleprintBootstrap = document.evaluate("//head/style[contains(.,'Bootstrap')]", document, null, XPathResult.ANY_TYPE).iterateNext();
            popupWinindow.document.write(`<html><head><title>Imprimir factura #${$scope.invoice.number}</title><style>${styleprint.innerHTML}</style><style>${styleprintBootstrap.innerHTML}</style></head><body onload="window.print()">${innerContents}</html>`);
            popupWinindow.document.close();
          };

          $scope.closeThisDialog = () => $uibModalInstance.close();
        }
      });
    }
  }

  getDiscount(item) { return item.discount; }
  getTotal(item) { return item.total; }
  getExtraTip(item) { return item.extra_tip; }
  getTax10(item) { return item.tax10; }
  getTax16(item) { return item.tax16; }

  isGroupedByDate() { return !this.rows.length || this.rows[0].hasOwnProperty('date') && !this.rows[0].hasOwnProperty('rnc'); }
  isGroupedByCashier() { return this.rows.length && this.rows[0].hasOwnProperty('cashier'); }
  isGroupedByTable() { return this.rows.length && this.rows[0].hasOwnProperty('table'); }
  isGroupedByInvoice() { return this.rows.length && this.rows[0].hasOwnProperty('date') && this.rows[0].hasOwnProperty('rnc'); }
  isGroupedByPOS() { return this.rows.length && this.rows[0].hasOwnProperty('pos'); }
  isGroupedByCategory() {return this.rows.length && this.rows[0].hasOwnProperty('pifamm_id'); }
  
  drillDownOnDate(rowDate) {
    this.dateFrom = this.moment(rowDate);
    this.dateTo = this.moment(rowDate);
    this.groupBy = '3';
    this.findOth();
  }

  drillDownOnCashier(cashierId) {
    this.groupBy = '3';
    this.findOth('15', cashierId);
  }

  drillDownOnPOS(posId) {
    this.groupBy = '3';
    this.findOth('16', undefined, posId);
  }

  drillDownOnCategory(familyId, famName) {
    this.state.go('salesByCategory', {
      famId: familyId,
      dateTo: this.dateTo,
      dateFrom: this.dateFrom,
      title: famName
    });
  }

  drillDownOnTable(tableId){
    this.groupBy = '3';
    let table = parseInt(tableId.split('-')[0].trim()) * 10;
    this.findOth('18', undefined, undefined, undefined, table);
  }

  reorderCsv(){
    this.getCsvHeaders();
    this.getCsvHeaderOrder();
  }

  getCsvHeaders(){
    const _ = this.trans;
    let usuals = [_('Pax'), _('Desc.'), _('Prop.Extra'), _('% Ley'), _('IVA'), _('Total')];
    if (this.isGroupedByCashier()) {
      this.csvHeaders = [_('Vendedor'), ...usuals];
    } else if (this.isGroupedByDate()) {
      this.csvHeaders = [_('Fecha'), ...usuals]
    } else if (this.isGroupedByInvoice()) {
      this.csvHeaders = [_('Fecha'), _('NCF'), _('RNC'), _('Nombre'), ...usuals];
    } else if (this.isGroupedByPOS()) {
      this.csvHeaders = [_('POS'), ...usuals];
    } else if (this.isGroupedByTable()) {
      this.csvHeaders = [_('Mesa'), ...usuals];
    }
  }

  getCsvHeaderOrder(){
    let usuals = ["pax", "discount","extra_tip",  "tax10", "tax16", "total"];
    if (this.isGroupedByCashier()) {
      this.csvHeaderOrder = ['cashier', ...usuals];
    } else if (this.isGroupedByDate()) {
      this.csvHeaderOrder = ['date', ...usuals]
    } else if (this.isGroupedByInvoice()) {
      this.csvHeaderOrder = ['date', 'ncf', 'rnc', 'Nombre', ...usuals];
    } else if (this.isGroupedByPOS()) {
      this.csvHeaderOrder = ['pos', ...usuals];
    } else if (this.isGroupedByTable()) {
      this.csvHeaderOrder = ['table', ...usuals];
    }
  }

}

 OthController.$inject = ['ContentService', '$uibModal', 'moment', 'isMobile', 'ProfilePermissionsService', '$state', '$translate'];


// WEBPACK FOOTER //
// ./src/app/pages/oth/oth.controller.js